import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { CountWithStatus } from '@/components/modules/Typography/TagText/CountWithStatus';
import { clientRfpOneMessagePath } from '@/utils/router/links';
export const RfpClientCountMessage = (props) => {
    const { className = '', id, isEnd, unanswerCount, unreadCount } = props;
    // ステータス
    const statusConfig = {
        color: 'orange',
        text: '未読',
    };
    // 未読の件数
    const countConfig = useMemo(() => ({
        inactive: unreadCount === 0,
        link: clientRfpOneMessagePath(id),
        number: unreadCount,
    }), [id, unreadCount]);
    // 未返信の件数
    const subConfig = useMemo(() => ({
        inactive: unanswerCount === 0,
        link: clientRfpOneMessagePath(id),
        text: `未返信${unanswerCount}件`,
    }), [id, unanswerCount]);
    return (_jsx(CountWithStatus, { className: className, countConfig: countConfig, inactiveAll: isEnd || (unreadCount === 0 && unanswerCount === 0), statusConfig: statusConfig, subConfig: subConfig }));
};
